import { IEirSalesSaveCustomerPhoneNumberPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveCustomerPhoneNumberPayload";

export const mapEirSalesSaveCustomerPhoneNumberPayload = (
    mobileNumber: string,
    prospectReference: string
): IEirSalesSaveCustomerPhoneNumberPayload => ({
    phoneNumber: mobileNumber,
    reference: prospectReference,
});
